/**
 * MCP 利用状況 APIクライアント
 */

import { AuthenticatedApiClient } from '../client';
import type { McpUsageResponse } from '@/lib/types/ai/mcpUsage';

/** MCP 利用状況の取得条件 */
export interface McpUsageParams {
  start_date: string;
  end_date: string;
  /** customer (既定) / internal / all */
  caller_type?: string;
  company_id?: string;
  account_code?: string;
  principal?: string;
  /** day (既定) / week / month */
  granularity?: string;
}

/**
 * MCP 利用状況を取得（認証付き）
 */
export async function getMcpUsageAuthenticated(
  authHeaders: Record<string, string>,
  params: McpUsageParams,
): Promise<McpUsageResponse> {
  try {
    const client = new AuthenticatedApiClient(authHeaders);
    const queryParams = new URLSearchParams();
    queryParams.append('start_date', params.start_date);
    queryParams.append('end_date', params.end_date);
    if (params.caller_type) queryParams.append('caller_type', params.caller_type);
    if (params.company_id) queryParams.append('company_id', params.company_id);
    if (params.account_code) queryParams.append('account_code', params.account_code);
    if (params.principal) queryParams.append('principal', params.principal);
    if (params.granularity) queryParams.append('granularity', params.granularity);

    const url = `/ai/mcp-usage?${queryParams.toString()}`;
    return await client.get<McpUsageResponse>(url);
  } catch (error) {
    console.error('Failed to fetch MCP usage:', error);
    throw error;
  }
}
